import { FC, InputHTMLAttributes } from "react";
import { RadioButton, RadioLabel } from "./Radio.styled";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const Radio: FC<Props> = ({ label, ...rest }) => {
  return (
    <RadioLabel disabled={rest.disabled} data-testid="radio-label">
      <RadioButton {...rest} type="radio" data-testid="radio" />
      <span data-testid="radio-name">{label}</span>
    </RadioLabel>
  );
};

export default Radio;
